/* 
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved. 
 */
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Authenticated, Unuthenticated, FallbackStoredUIValueComponent } from 'nmqf-common-ui';

import { IndexDashboard } from '../indexdashboard';
import { LoginComponent } from './login';

export const Authenticate = () => {
  return (
    <>
      <Unuthenticated>
        <Switch>
          <Route path="/" exact>
            <LoginComponent />
          </Route>
          <Redirect to="/" />
        </Switch>
      </Unuthenticated>
      <Authenticated>
        <Switch>
          <Route path="/" exact>
            <FallbackStoredUIValueComponent>
              <IndexDashboard />
            </FallbackStoredUIValueComponent>
          </Route>
          <Redirect to="/" />
        </Switch>
      </Authenticated>
    </>
  );
};
